import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import TopInfoStrip from "./components/TopInfoStrip";

import ScrollToTop from "./components/ScrollToTop";
import InquiryModal from "./components/InquiryModal";
import Home from "./pages/Home";
import LandingPage from "./pages/LandingPage";
import ServicePage from "./pages/ServicePage";
import ServiceDetail from "./pages/ServiceDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Resources from "./pages/Resources";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
// import ApplicationMain from "./pages/ApplicationMain";
import TrademarkRegistrationPage from "./pages/TrademarkRegistrationPage";
import PPCLandingPage from "./pages/PPCLandingPage";
import { Toaster } from "./components/ui/sonner";

// Layout wrapper to conditionally show navbar/footer
const landingPagePaths = ['/lp', '/trademark-registration', '/ppc'];

const Layout = ({ children, onOpenModal, isModalOpen, onCloseModal, modalContext, packageTitle, packageAmount, tmSignUpType }) => {
  const location = useLocation();
  const isLandingPage = landingPagePaths.includes(location.pathname.replace(/\/+$/, ''));

  return (
    <>
      {!isLandingPage && <TopInfoStrip />}
      {!isLandingPage && <Navbar onOpenModal={onOpenModal} />}
      {children}
      {!isLandingPage && <Footer />}
      <Toaster />
      <InquiryModal
        isOpen={isModalOpen}
        onClose={onCloseModal}
        buttonContext={modalContext}
        packageTitle={packageTitle}
        packageAmount={packageAmount}
        tmSignUpType={tmSignUpType}
      />
    </>
  );
};

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContext, setModalContext] = useState('');
  const [selectedPackage, setSelectedPackage] = useState({ title: 'Basic', amount: 45 });
  const [tmSignUpType, setTmSignUpType] = useState(null);

  const handleOpenModal = (payload) => {
    if (typeof payload === 'string') {
      setModalContext(payload);
      setTmSignUpType(null);
    } else {
      setModalContext(payload.context || '');
      setSelectedPackage({
        title: payload.packageTitle || 'Basic',
        amount: payload.packageAmount || 45
      });
      setTmSignUpType(payload.tmSignUpType || null);
    }
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalContext('');
    setTmSignUpType(null);
  };

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout
          onOpenModal={handleOpenModal}
          isModalOpen={isModalOpen}
          onCloseModal={handleCloseModal}
          modalContext={modalContext}
          packageTitle={selectedPackage.title}
          packageAmount={selectedPackage.amount}
          tmSignUpType={tmSignUpType}
        >
          <Routes>
            <Route path="/" element={<Home onOpenModal={handleOpenModal} />} />
            <Route path="/lp" element={<LandingPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/services/:serviceType" element={<ServicePage />} />
            <Route path="/services/:category/:serviceSlug" element={<ServiceDetail onOpenModal={handleOpenModal} />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blogs/:id" element={<BlogDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            {/* <Route path="/application/main" element={<ApplicationMain />} /> */}
            <Route path="/trademark-registration" element={<TrademarkRegistrationPage />} />
            <Route path="/ppc" element={<PPCLandingPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
